import { css } from 'styled-system/css';

export function NotFound() {
  return (
    <main
      className={css({
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      })}
    >
      <p className={css({ textStyle: 'monoLabel', color: 'text.muted' })}>
        404 — not found
      </p>
    </main>
  );
}
